/**
 * Course engine — Stockfish analysis for any course board.
 *
 *   const engine = useCourseEngine({fen, enabled, lines: 3, depth: 18});
 *     -> {engineElement, state, status, thinking}
 *
 *   {engine.engineElement}   // mount anywhere; renders nothing; null while off,
 *                            // so the worker only exists while `enabled`.
 *
 *   <CourseEnginePanel
 *     enabled={on} onToggle={setOn}
 *     state={engine.state} status={engine.status}
 *     onPlayLine={san => …} onHoverLine={line => …}   // optional
 *   >{optional extra under the eval}</CourseEnginePanel>
 *
 *   <CourseEvalBar score={engine.state.lines[0]?.score} height={boardSize} flipped={orientation === 'black'} />
 *
 *   const arrow = bestArrow(engine.state);  // [from, to] | null
 *   <ChessboardComponent {...(arrow ? {customArrows: [[...arrow, ENGINE_ARROW_COLOR]]} : {})} />
 *
 * `fen` is the board's CURRENT position; lines for any other position are
 * dropped. Scores are White's point of view. `status` is one of off |
 * starting | thinking | done | unavailable | checkmate | stalemate | draw —
 * "unavailable" covers both no Web Workers and a worker that never answered
 * within STARTUP_TIMEOUT_MS. In jest, mock '../../../Components/StockfishEngine'
 * (default export) and '…/StockfishEngine/engine' (isEngineSupported).
 */
export {useCourseEngine, STARTUP_TIMEOUT_MS} from './useCourseEngine';
export type {CourseEngine, CourseEngineOptions} from './useCourseEngine';
export {default as CourseEnginePanel} from './CourseEnginePanel';
export {default as CourseEvalBar} from './CourseEvalBar';
export * from './engineLogic';
